import React from 'react';

const ChannelAllocation = () => {
    return (
        <div>
            <video autoPlay loop muted controls={false} style={{ width: '100%', height: 'auto' }}>
                <source src={require('../video/channeluse.mp4')} type="video/mp4" />
                您的浏览器不支持 HTML5 视频标签。
            </video>
        </div>
    );
};

export default ChannelAllocation;